<div class="d-flex align-items-center justify-content-between mb-3">
  <h1 class="mb-0">Conference Eligibility</h1>
</div>

<app-conference-eligibility-widget></app-conference-eligibility-widget>
